import React, { useState, useEffect, useContext } from 'react';
// import PropTypes from "prop-types";
import cn from 'classnames';
import { withStyles } from '@material-ui/styles';
import { DynamicFormModal } from '../../DynamicForm';
import * as v from '../../../helpers/validation';
import { OrderDetailContext, useOrderDetailContext } from '../OrderDetailContext';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  CircularProgress,
  FormControlLabel,
} from '@material-ui/core';
import AsyncSelect from '../../DynamicForm/FormInputs/Select/AsyncSelect';

// SERVICES
import {
  getReportCodes,
  orderManipulationRecreate,
  orderManipulationReopen,
  orderManipulationConvert,
  orderManipulationLaunchRemote,
  orderManipulationRemoveHold,
  removeBetterViewData,
  addBetterViewData,
  saveMasterAgentByAgentId,
  convertOrder,
  getUnderwriterOptions,
  addressValidation,
  getClient,
  processPhotos,
  fetchBetterViewData,
  processAdvanceToQA,
  resendSelfInspectLink,
  sendSelfInspectReminder,
  aiPhotoReview,
  rebuildScreenshotImage,
  rerunHazardHubMigration,
} from '../../../services';
import { Box, Button, Modal } from '@material-ui/core';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import PhotoCameraOutlinedIcon from '@material-ui/icons/PhotoCameraOutlined';
import StorageOutlinedIcon from '@material-ui/icons/StorageOutlined';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import OrderResetButton from '../Buttons/OrderResetButton';
import { toBase64 } from '../../../helpers';
import { ConfirmationDialog } from '../../ConfirmationDialog';
import { AppContext } from '../../../AppContext';
import { fetchProperty } from '../../../services';
import { format, addDays } from 'date-fns';
import FormInput from '../../ReactHookForm/FormInput/FormInput';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm, useWatch } from 'react-hook-form';
import { Grid } from '@material-ui/core';
import { Redirect } from 'react-router';
import ColoredCheckbox from '../../ColoredInputs/ColoredCheckbox';
import { OrderReviewContext } from '../../QaOrderReview/OrderReviewContext';
import ROLES, { hasPermission } from '../../../helpers/roles';

const UPDATE_FORM_FIELDS = {
  REASON: 'reason',
  ORDER_LINE_ID: 'orderLineId',
  REPORT_CODE: 'reportCode',
  AGENT_NAME: 'agentname',
  AGENT_PHONE: 'agentphone',
  AGENT_EMAIL: 'agentemail',
  AGENT_CONTACT_NAME: 'agentcontactname',
  AGENT_CONTACT_PHONE: 'agentcontactphone',
  AGENT_CONTACT_EMAIL: 'agentcontactemail',
  INSURED_ADDRESS: 'insuredaddress',
  INSURED_CITY: 'insuredcity',
  INSURED_ZIP: 'insuredzip',
  INSURED_STATE: 'insuredstate',
  INSURED_NAME: 'insuredname',
  INSURED_PHONE_1: 'insuredphone1',
  INSURED_PHONE_2: 'insuredphone2',
  INSURED_EMAIL: 'insuredEmail',
  POLICY_NUMBER: 'policyNumber',
  UNDERWRITER: 'underwriterCode',
};

const CORRECTED_ADDRESS_FIELDS = {
  INSURED_ADDRESS: 'cinsuredaddress',
  INSURED_CITY: 'cinsuredcity',
  INSURED_ZIP: 'cinsuredzip',
  INSURED_STATE: 'cinsuredstate',
};

const actionModes = {
  REOPEN: 'REOPEN',
  RECREATE: 'RECREATE',
  CONVERT: 'CONVERT',
  LAUNCHREMOTE: 'LAUNCHREMOTE',
  REMOVEHOLD: 'REMOVEHOLD',
};

const styles = theme => ({
  // #region ACTIONS LAYOUT
  wrapper: {
    width: '100%',
    padding: 24,
    boxSizing: 'border-box',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    alignItems: 'start',
    gridGap: '24px',
    maxWidth: 1180,
    margin: '0 auto',
    textAlign: 'left',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
    },
  },
  card: {
    backgroundColor: '#fff',
    border: '1px solid #ececf0',
    borderRadius: 16,
    padding: '28px 28px 32px',
    boxShadow: '0 1px 3px rgba(16, 24, 40, 0.06)',
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 28,
  },
  iconCircle: {
    flex: '0 0 auto',
    width: 48,
    height: 48,
    marginRight: 22,
    borderRadius: '50%',
    backgroundColor: '#f2f4f7',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  cardIcon: {
    color: 'var(--jmi-blue)',
    fontSize: 24,
  },
  cardHeaderText: {
    minWidth: 0,
  },
  cardTitle: {
    margin: 0,
    fontSize: 19,
    fontWeight: 700,
    lineHeight: 1.25,
    color: '#1d2939',
    textAlign: 'left',
  },
  cardDesc: {
    margin: '6px 0 0',
    fontSize: 13.5,
    lineHeight: 1.45,
    color: '#667085',
    textAlign: 'left',
  },
  btnStack: {
    display: 'flex',
    flexDirection: 'column',
    '& > * + *': {
      marginTop: 8,
    },
  },
  cardBtn: {
    width: '100%',
    textTransform: 'none',
    fontWeight: 700,
    fontSize: 14,
    lineHeight: 1.4,
    borderRadius: 10,
    padding: '13px 16px',
    boxShadow: 'none',
  },
  cardBtn_primary: {
    border: '1.5px solid var(--jmi-blue)',
    color: 'var(--jmi-blue)',
    backgroundColor: '#fff',
    '&:hover': {
      backgroundColor: 'var(--jmi-blue)',
      color: '#fff',
    },
  },
  cardBtn_danger: {
    border: '1.5px solid var(--jmi-red)',
    color: 'var(--jmi-red)',
    backgroundColor: '#fff',
    '&:hover': {
      backgroundColor: 'var(--jmi-red)',
      color: '#fff',
    },
  },
  resetBtn: {
    width: '100%',
    textTransform: 'none',
    fontWeight: 700,
    fontSize: 14,
    lineHeight: 1.4,
    borderRadius: 10,
    padding: '13px 16px',
    boxShadow: 'none',
    border: '1.5px solid var(--jmi-blue)',
    color: 'var(--jmi-blue)',
    backgroundColor: '#fff',
    '&:hover': {
      backgroundColor: 'var(--jmi-blue)',
      color: '#fff',
    },
  },
  // #endregion
});

const submitFns = {
  [actionModes.RECREATE]: orderManipulationRecreate,
  [actionModes.REOPEN]: orderManipulationReopen,
  [actionModes.CONVERT]: orderManipulationConvert,
  [actionModes.LAUNCHREMOTE]: orderManipulationLaunchRemote,
  [actionModes.REMOVEHOLD]: orderManipulationRemoveHold,
};

export const OrderDetailActionsTab = withStyles(styles)(({ orderLineId, classes }) => {
  // #region STATE
  const [initData, setInitData] = useState({
    orderLineId,
    reportCode: '',
    reason: '',
    HomeownerDueDate: format(addDays(new Date(), 7), 'yyyy-MM-dd'),
  });
  const {
    state: { roles },
  } = useContext(AppContext);
  /* permission checks */
  const isCallCenter = hasPermission([ROLES.CALLCENTER], roles);
  /* permission checks */

  const [modalVisible, setModalVisible] = useState(false);
  const [actionMode, setActionMode] = useState(null);
  const [reportCodes, setReportCodes] = useState([]);
  const [betterViewModal, setBetterViewModal] = useState(false);
  const [bvData, setBvdata] = useState();
  const [updateOrderModal, showUpdateOrderModal] = useState(false);
  const [isUpdateOrderSaving, setUpdateOrderSaving] = useState(false);
  const [underwriterOptions, setUnderwriterOptions] = useState([]);
  const [underwriterDetails, setUnderwriterDetails] = useState(null);
  const [selectedUnderwriter, setSelectedUnderwriter] = useState(null);
  const [client, setClient] = useState(null);
  const [processingPhotos, setProcessingPhotos] = useState(false);
  const [aiPhotoReviewing, setAiPhotoReviewing] = useState(false);
  const [sendingSelfInspectReminder, setSendingSelfInspectReminder] = useState(false);
  const [rerunningHazardHubMigration, setRerunningHazardHubMigration] = useState(false);
  const [rebuildingScreenshot, setRebuildingScreenshot] = useState(false);
  const [advanceToQA, setAdvanceToQA] = useState(false);
  const [clickedUpdateOrder, setClickedUpdateOrder] = useState(false);
  const [addressModal, showAddressModal] = useState(false);
  const [formData, setFormData] = useState({});
  const [isValidAddress, setIsValidAddress] = useState();
  const [usingOriginalAddress, setUsingOriginalAddress] = useState(false);
  const [resendingNotifications, setResendingNotifications] = useState(false);
  // #endregion

  // #region formSchema
  // to avoid cyclic dependency, we give a list of unexhaustive field pairs
  // in the dependency array
  const formValidationSchema = Yup.object().shape(
    {
      [UPDATE_FORM_FIELDS.REASON]: Yup.string().required('Reason is required'),
      [UPDATE_FORM_FIELDS.ORDER_LINE_ID]: Yup.number(),
      [UPDATE_FORM_FIELDS.REPORT_CODE]: Yup.string(),
      [UPDATE_FORM_FIELDS.POLICY_NUMBER]: Yup.string(),
      [UPDATE_FORM_FIELDS.UNDERWRITER]: Yup.string()
        .nullable()
        .when('client?.result?.primaryEmailNull', {
          is: value => !!value,
          then: Yup.string().required('Underwriter is required for this order'),
        }),
      [UPDATE_FORM_FIELDS.AGENT_NAME]: Yup.string()
        .default('')
        .nullable(),
      [UPDATE_FORM_FIELDS.AGENT_PHONE]: Yup.string()
        .default('')
        .nullable(),
      [UPDATE_FORM_FIELDS.AGENT_EMAIL]: Yup.string()
        .default('')
        .nullable(),
      [UPDATE_FORM_FIELDS.AGENT_CONTACT_NAME]: Yup.string()
        .default('')
        .nullable(),
      [UPDATE_FORM_FIELDS.AGENT_CONTACT_PHONE]: Yup.string()
        .default('')
        .nullable(),
      [UPDATE_FORM_FIELDS.AGENT_EMAIL]: Yup.string()
        .default('')
        .nullable(),
      [UPDATE_FORM_FIELDS.INSURED_ADDRESS]: Yup.string().when(['insuredcity', 'insuredstate', 'insuredzip'], {
        is: (insuredcity, insuredstate, insuredzip) => insuredcity || insuredstate || insuredzip,
        then: Yup.string().required('This field is now required'),
      }),
      [UPDATE_FORM_FIELDS.INSURED_CITY]: Yup.string().when(['insuredaddress', 'insuredstate', 'insuredzip'], {
        is: (insuredaddress, insuredstate, insuredzip) => insuredaddress || insuredstate || insuredzip,
        then: Yup.string().required('This field is now required'),
      }),
      [UPDATE_FORM_FIELDS.INSURED_NAME]: Yup.string()
        .default('')
        .nullable(),
      [UPDATE_FORM_FIELDS.INSURED_PHONE_1]: Yup.string()
        .default('')
        .nullable(),
      [UPDATE_FORM_FIELDS.INSURED_PHONE_2]: Yup.string()
        .default('')
        .nullable(),
      [UPDATE_FORM_FIELDS.INSURED_EMAIL]: Yup.string()
        .default('')
        .nullable(),
      [UPDATE_FORM_FIELDS.INSURED_STATE]: Yup.string()
        .matches(/^[A-Za-z]+$/, 'Value must only contain alphabetical characters')
        .max(2)
        .when(['insuredcity', 'insuredaddress', 'insuredzip'], {
          is: (insuredcity, insuredaddress, insuredzip) => insuredcity || insuredaddress || insuredzip,
          then: Yup.string().required('This field is now required'),
        }),
      [UPDATE_FORM_FIELDS.INSURED_ZIP]: Yup.string().when(['insuredcity', 'insuredstate', 'insuredaddress'], {
        is: (insuredcity, insuredstate, insuredaddress) => insuredcity || insuredstate || insuredaddress,
        then: Yup.string().required('This field is now required'),
      }),
    },
    [
      ['insuredcity', 'insuredaddress'],
      ['insuredcity', 'insuredstate'],
      ['insuredcity', 'insuredzip'],
      ['insuredstate', 'insuredaddress'],
      ['insuredstate', 'insuredzip'],
      ['insuredstate', 'insuredcity'],
      ['insuredzip', 'insuredaddress'],
      ['insuredzip', 'insuredcity'],
      ['insuredzip', 'insuredstate'],
      ['insuredaddress', 'insuredstate'],
      ['insuredaddress', 'insuredcity'],
      ['insuredaddress', 'insuredzip'],
    ],
  );
  // #endregion

  const correctedValidationSchema = Yup.object().shape({
    [CORRECTED_ADDRESS_FIELDS.INSURED_ADDRESS]: Yup.string().when(['insuredcity', 'insuredstate', 'insuredzip'], {
      is: (insuredcity, insuredstate, insuredzip) => insuredcity || insuredstate || insuredzip,
      then: Yup.string().required('This field is now required'),
    }),
    [CORRECTED_ADDRESS_FIELDS.INSURED_CITY]: Yup.string().when(['insuredaddress', 'insuredstate', 'insuredzip'], {
      is: (insuredaddress, insuredstate, insuredzip) => insuredaddress || insuredstate || insuredzip,
      then: Yup.string().required('This field is now required'),
    }),
    [CORRECTED_ADDRESS_FIELDS.INSURED_ADDRESS]: Yup.string().when(['insuredcity', 'insuredstate', 'insuredzip'], {
      is: (insuredcity, insuredstate, insuredzip) => insuredcity || insuredstate || insuredzip,
      then: Yup.string().required('This field is now required'),
    }),
    [CORRECTED_ADDRESS_FIELDS.INSURED_CITY]: Yup.string().when(['insuredaddress', 'insuredstate', 'insuredzip'], {
      is: (insuredaddress, insuredstate, insuredzip) => insuredaddress || insuredstate || insuredzip,
      then: Yup.string().required('This field is now required'),
    }),
  });

  const { dispatch: appDispatch } = useContext(AppContext);

  // #region HOOKS
  const { state } = useOrderDetailContext();
  const { dispatch } = useContext(AppContext);

  const {
    state: { roles: userRoles },
  } = useContext(AppContext);

  const isQA = userRoles.includes('QA') && (!userRoles.includes('ADMIN'));
  const isQAorAdmin = isQA || userRoles.includes('ADMIN');
  const isDev = ["local", "Staging", "Development"].includes(process.env.REACT_APP_BACKEND_ENV);


  // const isQA = 
  // #endregion

  const formMethods = useForm({
    resolver: yupResolver(formValidationSchema),
    reValidateMode: 'onSubmit',
    defaultValues: {
      orderLineId,
      reportCode: state?.detail?.importLine?.reportcode,
    },
  });

  const cformMethods = useForm({
    resolver: yupResolver(correctedValidationSchema),
  });
  // #region COMPUTED
  const importLine = state?.detail?.importLine;
  const inspectorId = state?.detail?.inspectorId;
  const showResetButton = importLine?.reportcode?.includes('QVUE') || importLine?.reportcode?.endsWith('IQ');
  const hasRemoteService = state?.services;
  // #endregion

  const getBetterViewById = async () => {
    const data = fetchBetterViewData(orderLineId);
    setBvdata(data);
  };

  const orderActionInputs = [
    {
      inputType: 'text',
      field: 'orderLineId',
      label: 'Orderline ID',
      validate: [v.required()],
      disabled: true,
    },
    ...(actionMode === actionModes.CONVERT
      ? [
        {
          inputType: 'select',
          field: 'reportCode',
          label: 'Report Code',
          validate: [v.required()],
          options: reportCodes,
        },
        {
          inputType: 'text',
          field: 'newAddress',
          label: 'New Address (optional)',
          validate: [],
        },
      ]
      : []),
    ...(actionMode === actionModes.LAUNCHREMOTE
      ? [
        {
          inputType: 'date',
          field: 'HomeownerDueDate',
          label: 'Due Date',
          validate: [v.required()],
        },
        {
          inputType: 'text',
          field: 'RemoteContactName',
          label: 'Contact Name',
          validate: [v.required()],
        },
        {
          inputType: 'text',
          field: 'RemoteContactPhone',
          label: 'Contact Cell Phone',
          validate: [v.required(), v.phone()],
        },
        {
          inputType: 'file',
          field: 'RemoteContactPhoto',
          label: 'Contact Photo',
          validate: [v.required()],
          acceptedFiles: 'image/*',
          fileCountLimit: 1,
          style: {
            marginTop: 24,
          },
        },
      ]
      : []),
    ...(actionMode !== actionModes.LAUNCHREMOTE
      ? [
        {
          inputType: 'text',
          field: 'reason',
          label: 'Reason',
          validate: [v.required()],
        },
      ]
      : []),
  ];

  const getClientByIdAsync = async () => {
    try {
      if (state?.detail?.policy?.clientId) {
        const results = await getClient(state?.detail?.policy?.clientId);
        setClient(results);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleActionSubmit = async formData => {
    if (actionMode === actionModes.LAUNCHREMOTE) {
      const photoFile = formData.RemoteContactPhoto[0];
      const photoBase64 = await toBase64(photoFile.file);
      const photoBase64Trimmed = photoBase64.replace(/^data:image\/(png|jpg|jpeg);base64,/, '');

      return submitFns[actionMode]({
        ...formData,
        RemoteContactPhoto: photoBase64Trimmed,
      });
    }

    return submitFns[actionMode](formData);
  };

  // used for the address validation modal
  const handleCancelUpdateOrderModal = () => {
    showAddressModal(false);
  };

  // used for the update order details modal
  const handleCloseOrderDetailsModal = () => {
    formMethods.reset();
    cformMethods.reset();
    showUpdateOrderModal(false);
  };

  const handleUpdateOrderDetails = async form => {
    showAddressModal(false);
    setUpdateOrderSaving(true);

    try {
      const response = await convertOrder(form, usingOriginalAddress);

      if (response) {
        setUpdateOrderSaving(false);
      }

      appDispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          message: 'Order Updated.',
          variant: 'success',
        },
      });

      setClickedUpdateOrder(true);
    } catch (error) {
      setUpdateOrderSaving(false);
      console.log(error, error.message);
      appDispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          message: `${error.errorMessage ? error.errorMessage : error}`,
          variant: 'error',
        },
      });
    }
    showUpdateOrderModal(false);
    formMethods.reset();
  };

  const onSubmitInvalid = async errors => {
    console.log('invalid', errors);
  };
  const onSubmitValid = async form => {
    showAddressModal(true);

    let correctedAddress = await addressValidation(form);

    if (
      correctedAddress?.addressLine1 &&
      correctedAddress?.state &&
      correctedAddress?.city &&
      correctedAddress?.postalCode
    ) {
      setIsValidAddress(false);
    } else {
      setIsValidAddress(true);
    }

    cformMethods.setValue(CORRECTED_ADDRESS_FIELDS.INSURED_ADDRESS, correctedAddress?.addressLine1);
    cformMethods.setValue(CORRECTED_ADDRESS_FIELDS.INSURED_STATE, correctedAddress?.state);
    cformMethods.setValue(CORRECTED_ADDRESS_FIELDS.INSURED_CITY, correctedAddress?.city);
    cformMethods.setValue(CORRECTED_ADDRESS_FIELDS.INSURED_ZIP, correctedAddress?.postalCode);

    /** set original address lines */
    formMethods.setValue(UPDATE_FORM_FIELDS.INSURED_ADDRESS, form?.insuredaddress);
    formMethods.setValue(UPDATE_FORM_FIELDS.INSURED_STATE, form?.insuredstate);
    formMethods.setValue(UPDATE_FORM_FIELDS.INSURED_CITY, form?.insuredcity);
    formMethods.setValue(UPDATE_FORM_FIELDS.INSURED_ZIP, form?.insuredzip);

    // if (usingOriginalAddress) {
    //   // use the original address
    //   setFormData(form);
    //   console.log('original');
    // } else {
    //   // use the corrected address
    //   console.log('corrected');
    //   setFormData({
    //     ...form,
    //     insuredaddress: correctedAddress?.addressLine1,
    //     insuredcity: correctedAddress?.city,
    //     insuredstate: correctedAddress?.state,
    //     insuredzip: correctedAddress?.postalCode,
    //   });
    // }
    setFormData(form);
  };

  const handleRemoveBetterViewData = async () => {
    try {
      console.log('removing betterview data for orderLineId: ' + orderLineId);
      let result = await removeBetterViewData(orderLineId);
      setBetterViewModal(false);

      if (result) {
        dispatch({
          type: 'SET_SNACKBAR',
          snackbar: {
            isOpen: true,
            variant: 'success',
            message: 'Removed BetterView Data successfully!',
          },
        });
      } else {
        dispatch({
          type: 'SET_SNACKBAR',
          snackbar: {
            isOpen: true,
            variant: 'error',
            message: 'Could Not Remove BetterView Data',
          },
        });
      }
    } catch (err) {
      console.log('Error trying to remove betterview data' + err);
      dispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          variant: 'error',
          message: 'Could Not Remove BetterView Data',
        },
      });
    }
    setBetterViewModal(false);
  };

  const handleAddBetterViewData = async () => {
    try {
      console.log('Adding Betterview data for orderLineId: ' + orderLineId);
      let result = await addBetterViewData(orderLineId);

      if (result) {
        dispatch({
          type: 'SET_SNACKBAR',
          snackbar: {
            isOpen: true,
            variant: 'success',
            message: 'Added BetterView Data successfully!',
          },
        });
      } else {
        dispatch({
          type: 'SET_SNACKBAR',
          snackbar: {
            isOpen: true,
            variant: 'error',
            message: 'Could Not Add BetterView Data',
          },
        });
      }
    } catch (err) {
      console.log('Error trying to add Betterview data' + err);
      dispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          variant: 'error',
          message: 'Could Not Add BetterView Data',
        },
      });
    }
  };

  const handleProcessPhotos = async orderLineId => {
    setProcessingPhotos(true);
    let res = await processPhotosImmediatley(orderLineId);
    setProcessingPhotos(false);
  };

  const handleAiPhotoReview = async orderLineId => {
    setAiPhotoReviewing(true);
    let res = await reviewPhotosUsingAI(orderLineId);
    setAiPhotoReviewing(false);
  };

  const handleSendSelfInspectReminder = async orderLineId => {
    setSendingSelfInspectReminder(true);
    let res = await sendSelfInspectReminder(orderLineId);
    setSendingSelfInspectReminder(false);
  };

  const handleRebuildScreenshot = async orderLineId => {
    setRebuildingScreenshot(true);
    let res = await rebuildScreenshotImage(orderLineId);
    setRebuildingScreenshot(false);
  };

  const handleQAAdvance = async orderLineId => {
    setAdvanceToQA(true);
    let res = await advanceOrderToQA(orderLineId);
    setAdvanceToQA(false);
  };

  const openModal = mode => () => {
    setActionMode(mode);
    setModalVisible(true);
  };

  const handleVisibility = () => {
    setBetterViewModal(false);
  };

  const handleUseOriginalAddressOption = ev => {
    setUsingOriginalAddress(ev.target.checked);
  };

  const processPhotosImmediatley = async orderLineId => {
    console.log('processing photos for orderLineId: ' + orderLineId);
    try {
      let result = await processPhotos(orderLineId);

      if (result?.success) {
        dispatch({
          type: 'SET_SNACKBAR',
          snackbar: {
            isOpen: true,
            variant: 'success',
            message: result.message || 'Photos processed successfully!',
          },
        });
      } else if (result?.message) {
        dispatch({
          type: 'SET_SNACKBAR',
          snackbar: {
            isOpen: true,
            variant: 'error',
            message: result.message,
          },
        });
      } else {
        dispatch({
          type: 'SET_SNACKBAR',
          snackbar: {
            isOpen: true,
            variant: 'error',
            message: 'Could Not Process Photos',
          },
        });
      }
    } catch (err) {
      console.log('Could not process photos: ' + err);

      dispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          variant: 'error',
          message: err?.message || 'Could Not Process Photos',
        },
      });
    }
  };

  const reviewPhotosUsingAI = async orderLineId => {
    try {
      let result = await aiPhotoReview(orderLineId);
      if (result) {
        dispatch({
          type: 'SET_SNACKBAR',
          snackbar: {
            isOpen: true,
            variant: 'success',
            message: 'Photos reviewed successfully!',
          },
        });
      } else {
        dispatch({
          type: 'SET_SNACKBAR',
          snackbar: {
            isOpen: true,
            variant: 'error',
            message: 'Could Not Review Photos',
          },
        });
      }
    } catch (err) {
      console.log('Could not review photos' + err);

      dispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          variant: 'error',
          message: 'Could Not Review Photos',
        },
      });
    }
  };


  const advanceOrderToQA = async orderLineId => {
    console.log('advancing to qa: ' + orderLineId);
    try {
      let result = await processAdvanceToQA(orderLineId);
      console.log({ result })
      if (result) {
        dispatch({
          type: 'SET_SNACKBAR',
          snackbar: {
            isOpen: true,
            variant: 'success',
            message: 'Order Advanced Successfully!',
          },
        });
      } else {
        dispatch({
          type: 'SET_SNACKBAR',
          snackbar: {
            isOpen: true,
            variant: 'error',
            message: 'Could Not Advance Order',
          },
        });
      }
    } catch (err) {

      dispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          variant: 'error',
          message: 'Could Not Advance Order',
        },
      });
    }
  };

  const handleResendSelfInspectLink = async orderLineId => {
    try {
      let result = await resendSelfInspectLink(orderLineId);
      console.log(result);
      if (result) {
        dispatch({
          type: 'SET_SNACKBAR',
          snackbar: {
            isOpen: true,
            variant: 'success',
            message: result,
          },
        });
      } else {
        dispatch({
          type: 'SET_SNACKBAR',
          snackbar: {
            isOpen: true,
            variant: 'error',
            message: result || 'Could Not Resend Self Inspect Link',
          },
        });
      }
    } catch (err) {
      console.log('Could not resend self inspect link: ' + err);
      dispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          variant: 'error',
          message: err.message || 'Could Not Resend Self Inspect Link',
        },
      });
    }
  };

  const handleRerunHazardHubMigration = async () => {
    try {
      setRerunningHazardHubMigration(true);
      let result = await rerunHazardHubMigration(orderLineId);
      if (result) {
        dispatch({
          type: 'SET_SNACKBAR',
          snackbar: {
            isOpen: true,
            variant: 'success',
            message: result,
          },
        });
      } else {
        dispatch({
          type: 'SET_SNACKBAR',
          snackbar: {
            isOpen: true,
            variant: 'error',
            message: result || 'Could Not Rerun Hazard Hub Migration',
          },
        });
      }
      setRerunningHazardHubMigration(false);
    } catch (err) {
      console.log('Could not rerun hazard hub migration: ' + err);
      setRerunningHazardHubMigration(false);
      dispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          variant: 'error',
          message: err.message || 'Could Not Rerun Hazard Hub Migration',
        },
      });
    }
    
  };

  const shouldShowResendSelfInspectButton = () => {
    //console.log({statedata: state.detail})
    return (
      state?.detail?.orderLineGuid
    );
  };

  // #region EFFECTS
  useEffect(() => {
    const getReportCodesAsync = async () => {
      try {
        const codes = await getReportCodes(orderLineId);
        setReportCodes(codes);
      } catch (error) {
        console.log(error);
      }
    };

    getReportCodesAsync();
    getBetterViewById();
  }, []);
  // #endregion

  useEffect(() => {
    setInitData({
      ...initData,
      reportCode: actionMode === actionModes.UPDATE ? state.detail?.importLine.reportcode : '',
    });
  }, [actionMode]);

  // useEffect(() => {
  //   console.log(initData);
  // }, [initData]);

  useEffect(() => {
    let defaultValues = {};
    defaultValues.orderLineId = orderLineId;
    defaultValues.reportCode = importLine?.reportcode;
    defaultValues.insuredaddress = importLine?.insuredaddress;
    defaultValues.insuredstate = importLine?.insuredstate;
    defaultValues.insuredcity = importLine?.insuredcity;
    defaultValues.insuredzip = importLine?.insuredzip;
    defaultValues.agentname = importLine?.agentname;
    defaultValues.agentphone = importLine?.agentphone;
    defaultValues.agentemail = importLine?.agentemail;
    defaultValues.agentcontactname = importLine?.agentcontactname;
    defaultValues.agentcontactphone = importLine?.agentcontactphone;
    defaultValues.agentcontactemail = importLine?.agentcontactemail;
    defaultValues.policyNumber = importLine?.policy;
    defaultValues.insuredphone1 = importLine?.insuredphone1;
    defaultValues.insuredphone2 = importLine?.insuredphone2;
    defaultValues.insuredEmail = importLine?.insuredEmail;
    defaultValues.insuredname = importLine?.insuredname;
    defaultValues.underwriterCode = importLine?.underwritercode;
    defaultValues.inspectorId = inspectorId;
    formMethods.reset({ ...defaultValues });
  }, [importLine]);

  const showRebuildScreenshotButton = isQAorAdmin && (importLine?.reportcode.includes('RSVSFIQ') || importLine?.reportcode.includes('RSVRSFIQ'));


  useEffect(() => {
    const fetchData = async () => {
      // if (state?.detail?.policy?.clientId) {
      const res = await getUnderwriterOptions({ clientId: state?.detail?.policy?.clientId, limit: 100 });

      setUnderwriterOptions(res.filter(x => x.emailOutput !== false));
    };
    // };
    fetchData().catch(console.error);
  }, [state?.detail?.policy?.clientId]);

  useEffect(() => {
    getClientByIdAsync();
  }, [state?.detail?.policy?.clientId]);

  // #region ACTION CATEGORIES
  // The visibility of each action is unchanged from the original role-based
  // rendering; the buttons are only regrouped into cards. `actionBranch`
  // preserves the original precedence: QA wins over Call Center wins over default.
  const actionBranch = isQA ? 'QA' : isCallCenter ? 'CC' : 'DEFAULT';
  const isQABranch = actionBranch === 'QA';
  const isCCBranch = actionBranch === 'CC';
  const isDefaultBranch = actionBranch === 'DEFAULT';

  const renderActionButton = ({ key, label, onClick, disabled, look = 'primary' }) => (
    <Button
      key={key}
      onClick={onClick}
      disabled={disabled}
      variant="outlined"
      className={cn(classes.cardBtn, classes[`cardBtn_${look}`])}
    >
      {label}
    </Button>
  );

  const actionCategories = [
    {
      key: 'order',
      title: 'Order Actions',
      description: 'Update core order state and workflow position.',
      icon: <AssignmentOutlinedIcon className={classes.cardIcon} />,
      items: [
        (isCCBranch || isDefaultBranch) &&
          renderActionButton({
            key: 'update',
            label: 'Update Order Details',
            onClick: () => showUpdateOrderModal(true),
          }),
        (isCCBranch || isDefaultBranch) &&
          renderActionButton({
            key: 'remove-hold',
            label: 'Remove Hold',
            onClick: openModal(actionModes.REMOVEHOLD),
          }),
        (isCCBranch || isDefaultBranch) &&
          renderActionButton({
            key: 'advance-qa',
            label: advanceToQA ? 'Advancing Order to QA' : 'Advance Order to QA',
            disabled: advanceToQA,
            onClick: () => handleQAAdvance(orderLineId),
          }),
        isDefaultBranch &&
          renderActionButton({
            key: 'reopen',
            label: 'Reopen Order',
            onClick: openModal(actionModes.REOPEN),
          }),
      ],
    },
    {
      key: 'inspection',
      title: 'Inspection & Photo Actions',
      description: 'Trigger inspection, reminder, and image processing tasks.',
      icon: <PhotoCameraOutlinedIcon className={classes.cardIcon} />,
      items: [
        (isCCBranch || isDefaultBranch) &&
          !showResetButton &&
          renderActionButton({
            key: 'launch-remote',
            label: 'Launch Remote InVision',
            onClick: openModal(actionModes.LAUNCHREMOTE),
          }),
        (isCCBranch || isDefaultBranch) && showResetButton && (
          <OrderResetButton key="reset" orderLineId={orderLineId} className={classes.resetBtn} />
        ),
        (isCCBranch || isDefaultBranch) &&
          shouldShowResendSelfInspectButton() &&
          renderActionButton({
            key: 'resend-self-inspect',
            label: resendingNotifications ? 'Resending...' : 'Resend Self Inspect Link',
            disabled: resendingNotifications,
            onClick: () => handleResendSelfInspectLink(orderLineId),
          }),
        (isCCBranch || isDefaultBranch) &&
          isQAorAdmin &&
          isDev &&
          renderActionButton({
            key: 'send-self-inspect-reminder',
            label: sendingSelfInspectReminder ? 'Sending...' : 'Send Self Inspect Reminder',
            disabled: sendingSelfInspectReminder,
            onClick: () => handleSendSelfInspectReminder(orderLineId),
          }),
        (isQABranch || isDefaultBranch) &&
          renderActionButton({
            key: 'process-photos',
            label: processingPhotos ? 'Processing Photos' : 'Process Photos',
            disabled: processingPhotos,
            onClick: () => handleProcessPhotos(orderLineId),
          }),
        (isQABranch || isDefaultBranch) &&
          renderActionButton({
            key: 'ai-photo-review',
            label: aiPhotoReviewing ? 'AI Reviewing Photos' : 'AI Photo Review',
            disabled: aiPhotoReviewing,
            onClick: () => handleAiPhotoReview(orderLineId),
          }),
        isDefaultBranch &&
          showRebuildScreenshotButton &&
          renderActionButton({
            key: 'rebuild-screenshot',
            label: rebuildingScreenshot ? 'Rebuilding...' : 'Rebuild Screenshot',
            onClick: () => handleRebuildScreenshot(orderLineId),
          }),
      ],
    },
    {
      key: 'vendor',
      title: 'Vendor / Property Data',
      description: 'Manage BetterView and Hazard Hub information.',
      icon: <StorageOutlinedIcon className={classes.cardIcon} />,
      items: [
        (isQABranch || isDefaultBranch) &&
          renderActionButton({
            key: 'add-betterview',
            label: 'Add BetterView Data',
            disabled: !!!bvData,
            onClick: handleAddBetterViewData,
          }),
        (isQABranch || isDefaultBranch) &&
          renderActionButton({
            key: 'remove-betterview',
            look: 'danger',
            label: 'Remove BetterView Data',
            disabled: !!!bvData,
            onClick: () => setBetterViewModal(true),
          }),
        isDefaultBranch &&
          isQAorAdmin &&
          renderActionButton({
            key: 'rerun-hazard-hub',
            label: rerunningHazardHubMigration ? 'Rerunning...' : 'Rerun Hazard Hub Migration',
            disabled: rerunningHazardHubMigration,
            onClick: () => handleRerunHazardHubMigration(orderLineId),
          }),
      ],
    },
    {
      key: 'advanced',
      title: 'Advanced / Recovery Actions',
      description: 'Use with caution for recovery or administrative changes.',
      icon: <SettingsOutlinedIcon className={classes.cardIcon} />,
      items: [
        (isCCBranch || isDefaultBranch) &&
          renderActionButton({
            key: 'convert',
            label: 'Convert Order',
            onClick: openModal(actionModes.CONVERT),
          }),
        (isCCBranch || isDefaultBranch) &&
          renderActionButton({
            key: 'recreate',
            label: 'Recreate Order',
            onClick: openModal(actionModes.RECREATE),
          }),
      ],
    },
  ];
  // #endregion

  return (
    <>
      <div className={classes.wrapper}>
        <div className={classes.grid}>
          {actionCategories.map(category => {
            const items = category.items.filter(Boolean);
            if (!items.length) return null;

            return (
              <div key={category.key} className={classes.card}>
                <div className={classes.cardHeader}>
                  <div className={classes.iconCircle}>{category.icon}</div>
                  <div className={classes.cardHeaderText}>
                    <h3 className={classes.cardTitle}>{category.title}</h3>
                    <p className={classes.cardDesc}>{category.description}</p>
                  </div>
                </div>
                <div className={classes.btnStack}>{items}</div>
              </div>
            );
          })}
        </div>
        {/* Form Modal for adding services to Order Line */}
        <DynamicFormModal
          inputs={orderActionInputs}
          mode={'EDIT'}
          data={initData}
          onSave={handleActionSubmit}
          modalVisible={modalVisible}
          hideModal={() => setModalVisible(false)}
          redirectOnSuccess={'/orders/all'}
        // modalChildType={'input'}
        // hideSubmitButton={!orderableServices.length}
        // modalLabel={'Add Services'}
        />
        {/* <ConfirmationDialog
        variant="contained"
        title="Remove BetterView data"
        visible={betterViewModal}
        setVisibility={setBetterViewModal}
        cancelButton={<Button onClick={() => setBetterViewModal(false)}>Cancel</Button>}
        acceptButton={<Button onClick={() => handleRemoveBetterViewData()}>Confirm</Button>}
      >
        <Box className="text-center" style={{ fontSize: '24px' }}>
          Removing BetterView data will remove all BetterView data associated with this order. Are you sure you want to
          proceed?
        </Box>
      </ConfirmationDialog> */}
        <React.Fragment>
          <Dialog
            maxWidth="sm"
            open={betterViewModal}
            onClose={() => setBetterViewModal(false)}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">Remove BetterView Data</DialogTitle>
            <DialogContent>
              <Box>
                Warning! Removing Betterview data from this order is an irreversible action, are you sure you want to
                proceed?
              </Box>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
              <Button color="secondary" onClick={() => setBetterViewModal(false)}>
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={handleRemoveBetterViewData}
                style={{
                  // marginLeft: 10,
                  backgroundColor: '#17c80d',
                  color: '#fff',
                }}
              >
                Confirm
              </Button>
            </DialogActions>
          </Dialog>
        </React.Fragment>
      </div>
      <Dialog
        maxWidth="sm"
        open={updateOrderModal}
        onClose={() => showUpdateOrderModal(false)}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Update Order Details</DialogTitle>
        <FormProvider {...formMethods} schema={formValidationSchema}>
          <form onSubmit={formMethods.handleSubmit(onSubmitValid, onSubmitInvalid)}>
            <DialogContent>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <FormInput type="text" name={UPDATE_FORM_FIELDS.REASON} label="Reason" />
                </Grid>
                <Grid item xs={4}>
                  <FormInput
                    type="text"
                    name={UPDATE_FORM_FIELDS.ORDER_LINE_ID}
                    label="Order Line ID"
                    inputProps={{ readOnly: true }}
                  />
                  <FormInput
                    type="text"
                    name={UPDATE_FORM_FIELDS.REPORT_CODE}
                    label="Report Code"
                    inputProps={{ readOnly: true }}
                  />
                  <FormInput type="text" name={UPDATE_FORM_FIELDS.POLICY_NUMBER} label="Policy Number *" />
                  {/* <AsyncSelect
                    excludeEmailOutFalse={false}
                    isMutli
                    defaultValue={underwriterDetails?.underwriterCode}
                    value={[1, 2]}
                    onChange={(e, v) => console.log({ e, v })}
                    fetchOptions={queryOpts => {
                      return getUnderwriterOptions({
                        ...queryOpts,
                        clientId: state?.detail?.policy?.clientId,
                      });
                    }}
                    queryParamDefaultKey={'underwriter'}
                    i={{
                      isMulti: true,
                      label: 'Underwriter',
                      field: 'underwriter',
                    }}
                  /> */}
                  <FormInput
                    type="select"
                    label="Underwriter *"
                    name={UPDATE_FORM_FIELDS.UNDERWRITER}
                    options={underwriterOptions}
                  />
                </Grid>
                <Grid item xs={4}>
                  <FormInput type="text" name={UPDATE_FORM_FIELDS.INSURED_ADDRESS} label="Insured Address *" />
                  <FormInput type="text" name={UPDATE_FORM_FIELDS.INSURED_CITY} label="Insured City *" />
                  <FormInput type="text" name={UPDATE_FORM_FIELDS.INSURED_STATE} label="Insured State *" />
                  <FormInput type="text" name={UPDATE_FORM_FIELDS.INSURED_ZIP} label="Insured Zip *" />
                  <FormInput type="text" name={UPDATE_FORM_FIELDS.INSURED_NAME} label="Insured Name *" />
                  <FormInput type="text" name={UPDATE_FORM_FIELDS.INSURED_PHONE_1} label="Insured Phone 1" />
                  <FormInput type="text" name={UPDATE_FORM_FIELDS.INSURED_PHONE_2} label="Insured Phone 2" />
                  <FormInput type="text" name={UPDATE_FORM_FIELDS.INSURED_EMAIL} label="Insured Email" />
                </Grid>
                <Grid item xs={4}>
                  <FormInput type="text" name={UPDATE_FORM_FIELDS.AGENT_NAME} label="Agent Name *" />
                  <FormInput type="text" name={UPDATE_FORM_FIELDS.AGENT_PHONE} label="Agent Phone *" />
                  <FormInput type="text" name={UPDATE_FORM_FIELDS.AGENT_EMAIL} label="Agent Email *" />
                  <FormInput type="text" name={UPDATE_FORM_FIELDS.AGENT_CONTACT_NAME} label="Agent Contact Name *" />
                  <FormInput type="text" name={UPDATE_FORM_FIELDS.AGENT_CONTACT_PHONE} label="Agent Contact Phone *" />
                  <FormInput type="text" name={UPDATE_FORM_FIELDS.AGENT_CONTACT_EMAIL} label="Agent Contact Email *" />
                </Grid>
              </Grid>
              <span>* Modifying these fields will cause the system to create a new order</span>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
              <Button color="secondary" onClick={handleCloseOrderDetailsModal}>
                Cancel
              </Button>
              <Button
                variant="contained"
                type="submit"
                style={{
                  // marginLeft: 10,
                  backgroundColor: '#17c80d',
                  color: '#fff',
                }}
              >
                {isUpdateOrderSaving ? <CircularProgress style={{ fill: '#fff', color: '#fff' }} size={25} /> : 'Save'}
              </Button>
            </DialogActions>
          </form>
        </FormProvider>
        {clickedUpdateOrder && !isUpdateOrderSaving && <Redirect to="/orders/all" />}
      </Dialog>
      <Dialog
        maxWidth="md"
        fullWidth={true}
        open={addressModal}
        onClose={() => showAddressModal(false)}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Corrected Address</DialogTitle>

        <DialogContent>
          <Grid container spacing={2}>
            <Grid xs={12} style={{ paddingLeft: 10, paddingRight: 10 }}>
              A valid corrected address is found from the original address entered. If you need to override the address,
              please contact technical support. Otherwise, clicking confirm will update the order with the corrected
              address.
            </Grid>
            <FormProvider {...formMethods} schema={formValidationSchema}>
              <Grid item xs={6}>
                Original Address:
                <FormInput
                  type="text"
                  name={UPDATE_FORM_FIELDS.INSURED_ADDRESS}
                  label="Insured Address"
                  inputProps={{ readOnly: true }}
                />
                <FormInput
                  type="text"
                  name={UPDATE_FORM_FIELDS.INSURED_CITY}
                  label="Insured City"
                  inputProps={{ readOnly: true }}
                />
                <FormInput
                  type="text"
                  name={UPDATE_FORM_FIELDS.INSURED_STATE}
                  label="Insured State"
                  inputProps={{ readOnly: true }}
                />
                <FormInput
                  type="text"
                  name={UPDATE_FORM_FIELDS.INSURED_ZIP}
                  label="Insured Zip"
                  inputProps={{ readOnly: true }}
                />
              </Grid>
            </FormProvider>
            <FormProvider {...cformMethods} schema={correctedValidationSchema}>
              <Grid item xs={6}>
                Corrected Address:
                <FormInput
                  type="text"
                  name={CORRECTED_ADDRESS_FIELDS.INSURED_ADDRESS}
                  label="Insured Address"
                  inputProps={{ readOnly: true }}
                />
                <FormInput
                  type="text"
                  name={CORRECTED_ADDRESS_FIELDS.INSURED_CITY}
                  label="Insured City"
                  inputProps={{ readOnly: true }}
                />
                <FormInput
                  type="text"
                  name={CORRECTED_ADDRESS_FIELDS.INSURED_STATE}
                  label="Insured State"
                  inputProps={{ readOnly: true }}
                />
                <FormInput
                  type="text"
                  name={CORRECTED_ADDRESS_FIELDS.INSURED_ZIP}
                  label="Insured Zip"
                  inputProps={{ readOnly: true }}
                />
              </Grid>
            </FormProvider>
            {isValidAddress && (
              <Grid xs={12} style={{ paddingLeft: 10, paddingRight: 10, color: 'red' }}>
                The address entered could not be found! Please make sure you have entered the approprate fields, Or
                check Use Original Address and click the Confirm button.
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <FormControlLabel
            control={<ColoredCheckbox onChange={handleUseOriginalAddressOption} />}
            label="Use Original Address"
          />
          <Button color="secondary" onClick={handleCancelUpdateOrderModal}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => handleUpdateOrderDetails(formData)}
            style={{
              // marginLeft: 10,
              backgroundColor: isValidAddress ? (usingOriginalAddress ? '#17c80d' : 'gray') : '#17c80d',
              color: '#fff',
            }}
            disabled={isValidAddress ? !usingOriginalAddress : isValidAddress}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
});

OrderDetailActionsTab.propTypes = {};

OrderDetailActionsTab.default = {};
